'use strict';

var util = angular.module('gymsystem.util');

util.directive('opendoor', ['$rootScope', 'util', 'server', function($rootScope, util, server) {
    return {
        restrict: 'E',
        template: '<button class="btn btn-success btn-block-mobile" ng-click="openDoor()" ladda="loading" data-style="expand-left">{{title()}}</button>',
        scope: {
            settings: '='
        },
        link: function($scope) {
            $scope.loading = false;
            $scope.openDoor = function() {
                $scope.loading = true;
                server.post('/api/door/open', null, {id: $scope.door.id, admin_entry: true}).then(function() {
                    $scope.loading = false;
                });
            };

            $rootScope.waitFor(['staffs']).then(function() {
                $scope.door = $rootScope.getPointerById($scope.settings.door, $rootScope.staffs);
                $scope.title = () => util.t($scope.settings.buttontext).replaceAll('{name}', $scope.door.name);
            });
        }
    };
}]);

